import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    styled,
    Button
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import CommonBreadcumbs from "../common/CommonBreadcumbs"
import DataGridToolbar from '../common/DataGridToolbar';
import DataGridTable from '../common/DataGridTable';
import CommonRestricted from '../common/CommonRestricted';
import DataGridRowActionMenu from '../common/DataGridRowActionMenu';

import { icons } from '../common/CommonIcons';
// import { useCustomFields, customFieldModules, customFieldFunctions } from '../../hooks/api/useCustomFields';
import { useInjectionProps, propTypes as injectionPropTypes, targetTypes as injectionPropTargetTypes } from '../../hooks/api/useInjectionProps';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';
import { useTranslations } from "../../hooks/useTranslations";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function ListInjectionProps({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@injectionProp", "prompt"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    // const { list, remove } = useCustomFields(customFieldModules.item, customFieldFunctions.item.item);
    const { list, remove } = useInjectionProps({ propType: "", targetType: "" });

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.injectionProp.id, scopeTypes[scopeIds.injectionProp.id].injectionProp.id)

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const [selectedPropType, setSelectedPropType] = useState("")
    const [selectedPropType1, setSelectedPropType1] = useState("")
    const [selectedPropType2, setSelectedPropType2] = useState("")

    const [currentData, setCurrentData] = useState([])

    const gridRef = React.createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        // must check use key
        if (!selectedPropType) {
            return {
                data: [],
                count: 0
            }
        }

        resetDataGridTableSelection();

        try {

            if (!props?.sortInfo) props.sortInfo = {
                id: "type",
                dir: 0,
            }

            // console.log('props', props)
            props.targetType = selectedPropType

            const result = await list(props)

            let dataParsed = []

            result?.data?.injection_props_types.forEach((i, index) => {

                let id = `${i.props_ref}_${i.props_module}_${i.type}`

                i.id = id.toLowerCase()
                dataParsed.push(i)
            })

            setCurrentData(dataParsed)

            return {
                data: dataParsed,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    // useEffect(() => {

    //     console.log('1', refreshDataGrid)
    //     setRefreshDataGrid(1)

    // }, [selectedPropType])

    const defineColumnsView = () => {
        defineColumns([
            // {
            //     name: 'id',
            //     header: 'id'
            // },
            {
                name: 'props_module',
                header: t('module'),
                defaultFlex: 0,
                defaultWidth: 130,
                renderValue: ({ value, cellProps }) => {

                    // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                    //     return getRenderColumnTextDisplay(value)
                    // }

                    // let path = getRoute(`injectionProp/update/${cellProps.data.id}`);

                    // return getRenderColumnLink(path, value)

                    return value

                }
            },
            {
                name: 'props_ref',
                header: t('reference'),
                defaultFlex: 0,
                defaultWidth: 130,
            },
            {
                name: 'props_field',
                header: t('fieldType'),
                defaultFlex: 0,
                defaultWidth: 130,
            },
            {
                name: 'type',
                header: t('propKey'),
                defaultFlex: 0,
                defaultWidth: 300,
            },
            {
                name: 'is_multiple',
                header: t('isMultiple'),
                defaultFlex: 0,
                defaultWidth: 120,
                textAlign: 'center',
                renderValue: ({ value, cellProps }) => {

                    return parseInt(value, 10) === 1 ? t("yes") : t("no")

                }
            },
            {
                name: 'row_count',
                header: t('usedNo'),
                textAlign: 'center',
                defaultFlex: 0,
                defaultWidth: 120,
            },
        ])
    }

    const handleOnSubmit = () => {

        let useKey = ''

        if (selectedPropType1) useKey = (selectedPropType1)
        if (selectedPropType2) useKey = (selectedPropType2)

        if (!useKey) {
            promptMessage(false, t('pleaseSelectAtLeastAnyProperty'))
            return false
        }

        setRefreshDataGrid(refreshDataGrid + 1)
        setSelectedPropType(useKey)
        return true

    }

    const handleDelete = async () => {

        try {

            let keys = [];
            let propsModule = '';
            let propsRef = '';

            // find back the key from id
            selectedIds.forEach((i, index) => {

                const a = currentData.filter(i2 => i2.id === (i))

                console.log('currentData', currentData, i)

                if (a.length) {
                    keys.push(a[0]?.type)
                    propsModule = a[0]?.props_module
                    propsRef = a[0]?.props_ref
                }
            })

            // console.log('keys, keys', keys)

            let data = {
                props_module: propsModule,
                props_ref: propsRef,
                keys
            }

            if (keys.length <= 0) {
                promptMessage(false, `Invalid Keys`)
                return false
            }

            let result = await remove({ data, propType: selectedPropType })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

        } catch (error) {
            promptMessage(false, error?.message)
        }

        return true

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {
                        navigate(getRoute("settings/injectionProp/new"));
                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('item,s', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    const RenderFilters = () => {

        // get the inner props
        let selectMainPropertyId = selectedPropType1

        let innerProperties = []

        if (selectMainPropertyId) {
            Object.keys(injectionPropTypes[selectMainPropertyId]).forEach(i => {
                innerProperties.push(injectionPropTypes[selectMainPropertyId][i])
            })
        }

        let mainTargetTypes = Object.keys(injectionPropTargetTypes).filter(i => injectionPropTargetTypes[i].isMain === true)

        return (
            <StyledCard>
                <Grid container spacing={2}>
                    <Grid item xs={10} md={10} sm={10}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                        // error={touched.branchAccessId && Boolean(errors.branchAccessId)}
                        >
                            <InputLabel id="branch">{t("mainProperty")}</InputLabel>
                            <Select
                                fullWidth
                                // labelId="branchAccessId"
                                label="Main Property"
                                // name={"branchAccessId"}
                                onChange={(e) => setSelectedPropType1(e.target.value)}
                                value={selectedPropType1}
                            >
                                {
                                    mainTargetTypes.map((i, index) => {

                                        let description = injectionPropTargetTypes[i].description

                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i}
                                            >
                                                {/* <Checkbox checked={values.branchAccessId.indexOf(i.id) > -1} /> */}
                                                {/* <ListItemText primary={`${i.branch_name} (${i.branch_code})`} /> */}
                                                {`${i} - ${description}`}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            {/* <FormHelperText>
                                    {touched.branchAccessId && errors.branchAccessId}
                                </FormHelperText> */}
                        </FormControl>
                    </Grid>
                    {/* <Grid item xs={5} md={5} sm={5}> */}
                    {/* <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                        // error={touched.branchAccessId && Boolean(errors.branchAccessId)}
                        >
                            <InputLabel id="branch">Inner Property</InputLabel>
                            <Select
                                fullWidth
                                // labelId="branchAccessId"
                                label="Inner Property"
                                // name={"branchAccessId"}
                                onChange={(e) => setSelectedPropType2(e.target.value)}
                                value={selectedPropType2}
                            >
                                {
                                    innerProperties.map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i?.key}
                                            >
                                                {i?.id}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl> */}
                    <></>
                    {/* </Grid> */}

                    <Grid item xs={2} md={2} sm={2} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-end"}>

                        <Button
                            variant='contained'
                            color='primary'
                            fullWidth
                            type='button'
                            onClick={handleOnSubmit}
                        >
                            {t('browseProps')}
                        </Button>

                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderMain = () => {
        return (
            <>
                {
                    RenderFilters()
                }
                {
                    RenderToolbar()
                }
                {
                    RenderDataGridTable()
                }
            </>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.injectionProps })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('injectionProps')}
                // pageSubTitle="customers in your system"
                breadcrumbs={[
                    {
                        displayText: t("injectionProps"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />
            {/* {
                JSON.stringify(currentData)
            }
            {
                JSON.stringify(selectedIds)
            } */}

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderMain()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
